module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.payments) ? _c('f7-list', {
    staticClass: "itemList",
    attrs: {
      "accordion-list": "",
      "id": "payments-item-received"
    }
  }, _vm._l((_vm.payments), function(payment) {
    return _c('f7-accordion-item', {
      key: payment.id,
      staticClass: "accordionForm"
    }, [_c('f7-accordion-toggle', {
      staticClass: "accordionToggle"
    }, [_c('ul', [_c('li', {
      staticClass: "swipeout",
      staticStyle: {
        "background": "#dcdcdc"
      }
    }, [_c('div', {
      staticClass: "item-content boxRequest"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('div', {
      style: ({
        background: _vm.rectangleColor
      }),
      attrs: {
        "id": "greenRectangle"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon list-icon",
      class: _vm.getIcon(payment.status)
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('table', {
      staticStyle: {
        "table-layout": "fixed"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                    " + _vm._s(payment.reason) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.amnt') + ': ' + payment.amount + ' €') + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly statusLabel"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.payment_date') + ' ') + " " + _vm._s(_vm._f("formatDate")(payment.requestedExecutionDate)) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.endtoendid_label') + ': ' + payment.endToEndId) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "32%",
        "min-width": "32%",
        "max-width": "32%"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.amnt') + ': ' + payment.amount + ' €') + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "33%",
        "min-width": "33%",
        "max-width": "33%"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#8e8e93"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.payment_date') + ' ') + " " + _vm._s(_vm._f("formatDate")(payment.requestedExecutionDate)) + "\n                  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "statusLabel"
    }, [_vm._v("\n                  " + _vm._s(_vm.getStatusLabel(payment.status)) + "\n                ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.endtoendid_label') + ': ' + payment.endToEndId) + "\n                ")])])])])])])])]), _vm._v(" "), _c('f7-accordion-content', {
      staticClass: "background-document-form left-box"
    }, [_c('direct-payment-details', {
      staticClass: "container-document-form",
      attrs: {
        "payment": payment,
        "showMainDetails": _vm.showPaymentMainDetails
      }
    })], 1)], 1)
  }), 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8dd0b1fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dd0b1fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/directPaymentDetailPages/DirectPaymentsList.vue
// module id = 2481
// module chunks = 2